
  import { Vue, Component, Prop, PropSync, Watch } from 'vue-property-decorator'
  import CoolLightBox from 'vue-cool-lightbox'
  @Component({
    components: {
      CoolLightBox
    }
  })

  export default class General extends Vue  {
    selected = []
    addPhotoDialog = false
    index = null
    loading = false
    editedItem: any = {
      images: null,
      bridgePhotoFolderId: null
    }
    
    @Prop() readonly item!: any
    @Prop() readonly tab!: number
    @PropSync('galleryDialog', { type: Boolean }) compGalleryDialog!: boolean

    //Methods
    public cancel(): void {
      this.compGalleryDialog = false
    }

    public close(): void {
      this.$store.commit('bridge/setBridgeFolderPhotos', [])
      this.compGalleryDialog = false
    }

    public addBridgePhoto(): void {
      this.editedItem.bridgePhotoFolderId = this.item.id
      this.$store.dispatch('bridge/addBridgePhoto', this.editedItem)
      this.editedItem.image = null
      this.addPhotoDialog = false
    }

    public deleteSelected(): void {
      const photoid: number[] = []
      this.selected.forEach( id => {
        photoid.push(this.getBridgeFolderPhotos[id].id)
      })
      this.$store.dispatch('bridge/deleteBridgePhotos', {'selected': photoid})
      this.selected = []
    }
    public saveSelected(): void {
      const photoid: number[] = []
      this.selected.forEach( id => {
        photoid.push(this.getBridgeFolderPhotos[id].id)
      })
      this.$store.dispatch('bridge/downloadSelectedBridgePhoto', {'selected': photoid})
    }

    public imageGallery(): void {
      this.index = 0
    }

    //Getters
    get processEnvApi(): any {
      return process.env.VUE_APP_TRAFFIC_API;
    }
    get getBridgeFolderPhotos(): any {
      return this.$store.getters['bridge/getBridgeFolderPhotos']
    }
    get getReload(): boolean {
      return this.$store.getters['bridge/getReload']
    }
    get getMessage(): string {
      return this.$store.getters['bridge/getMsg']
    }
    get getErrors(): Array<string> {
      return this.$store.getters['bridge/getErrors']
    }
    get getDeletePermissions(): string {
      return this.$store.getters['auth/getPermissions'].includes('Bridge Admin')
    }
    get getEditPermissions(): string {
      return this.$store.getters['auth/getPermissions'].includes('Bridge Editor') ||
              this.$store.getters['auth/getPermissions'].includes('Bridge Admin')
    }

    //Watchers
    @Watch('compGalleryDialog')
    async refresh(val: boolean) {
      if(val && this.compGalleryDialog) { ///ddd??
        this.selected = []
        this.loading = true
        await this.$store.dispatch('bridge/getBridgeFolderPhotos', { id: this.item.id })
        this.loading = false
        this.$store.commit('bridge/setReload', false)
      }
    }
    @Watch('getReload')
    async reload(val: boolean) {
      if(val && this.compGalleryDialog && this.tab == 5) { ///ddd??
        this.loading = true
        await this.$store.dispatch('bridge/getBridgeFolderPhotos', { id: this.item.id })
        this.loading = false
        this.$store.commit('bridge/setReload', false)
      }
    }
    @Watch('getBridgeFolderPhotos')
    setItem(val: any) {
      //this.$store.commit('bridge/setReload', false)
    }
  }



